import { toast, Slide } from 'react-toastify';

const option = {
  transition: Slide,
  position: 'bottom-left',
};

function success(msg) {
  return toast.success(msg, option);
}

function info(msg) {
  return toast.info(msg, option);
}

function error(msg) {
  return toast.error(msg, option);
}

function warning(msg) {
  return toast.warning(msg, option);
}

function isActive(toastId) {
  return toast.isActive(toastId);
}

export default {
  success,
  info,
  error,
  warning,
  isActive
};


// WEBPACK FOOTER //
// ./src/components/Toastify.js